import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginFlow } from './login-thunk';

const Login = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loginFlow());
    }, []);
    return null;
};

export default Login;
